module.exports = __webpack_public_path__ + "static/carousel-2-e9e74582b5a22cb675b83e55009e3e44.png";